import { useQuery } from '@tanstack/react-query'
import { usePlatformGuard } from '@/hooks/usePlatformGuard'
import { fetchSubscriberCount } from '@/services/constellationService'

export function subscriberCountQueryKey(publicationUri: string) {
    return ['subscriberCount', publicationUri] as const
}

export function useSubscriberCount(publicationUri: string | undefined): {
    data: number | null
    isLoading: boolean
} {
    const isAtProto = usePlatformGuard('atproto')

    const { data = null, isLoading } = useQuery({
        queryKey: subscriberCountQueryKey(publicationUri ?? ''),
        queryFn: () => fetchSubscriberCount(publicationUri!),
        enabled: !!publicationUri && isAtProto,
        staleTime: 5 * 60 * 1000,
        retry: false,
    })

    return { data, isLoading }
}
